import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidatorComponent } from '@feature/survey-management/components/validator/validator.component';
import { TranslateModule } from '@ngx-translate/core';
import { Icon } from '@shared/components/icon/icon.enum';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { SingleSelect } from '@shared/models/question-types/single-select';
import { SafeHtmlPipe } from '../../../../../../../shared/pipes/safe-html.pipe';
import { ToValidIdPipe } from '../../../../../../../shared/pipes/to-valid-id.pipe';
import { SingleSelectRadioButtonComponent } from '../../../single-select-questions/single-select/single-select-radio-button/single-select-radio-button.component';
import { SliderComponent } from '../../../single-select-questions/slider/slider.component';

@Component({
  selector: 'app-matrix-single-select-row',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    SingleSelectRadioButtonComponent,
    ValidatorComponent,
    SliderComponent,
    SafeHtmlPipe,
    ToValidIdPipe,
  ],
  templateUrl: './matrix-single-select-row.component.html',
  styleUrl: './matrix-single-select-row.component.scss',
})
export class MatrixSingleSelectRowComponent implements OnInit, OnDestroy {
  @Input({ required: true }) control!: any;
  @Input() otherControl?: any;
  @Input() question!: SingleSelect;
  @Input() matrixQuestionId?: string;
  @Input() hideError = false;
  Icon = Icon;
  ValidatorType = ValidatorType;

  constructor() {
    this.isMobileView = window.innerWidth < 768;
  }

  isMobileView: boolean;

  ngOnInit(): void {
    window.addEventListener('resize', this.onResize.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize.bind(this));
  }

  onResize(event: Event): void {
    this.isMobileView = (event.target as Window).innerWidth < 768;
  }
}
